import {
  OPEN_MODAL_KUDOS_TAB,
  OPEN_MODAL_COMMENTS_TAB,
  OPEN_MODAL_ACHIEVEMENTS_TAB,
  CLOSE_MODAL,
  UPDATE_KUDO_STATUS,
  KUDO_STATUS_UPDATE_COMPLETED,
  COMMENT_SUBMITTED
} from './feed-entity-actions';

export function init({
  openKudosCommentModal,
  selectedTabIndex,
  kudoPosted,
  newComment,
  analyticsContext
}) {
  return {
    openKudosCommentModal,
    selectedTabIndex,
    kudoPosted,
    newComment,
    analyticsContext
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case OPEN_MODAL_KUDOS_TAB:
      return { ...state, openKudosCommentModal: true, selectedTabIndex: 0 };
    case OPEN_MODAL_COMMENTS_TAB:
      return { ...state, openKudosCommentModal: true, selectedTabIndex: 1 };
    case OPEN_MODAL_ACHIEVEMENTS_TAB:
      return { ...state, openKudosCommentModal: true, selectedTabIndex: 2 };
    case CLOSE_MODAL:
      return { ...state, openKudosCommentModal: false, selectedTabIndex: 0 };
    case UPDATE_KUDO_STATUS:
      return { ...state, kudoPosted: true };
    case KUDO_STATUS_UPDATE_COMPLETED:
      return { ...state, kudoPosted: false };
    case COMMENT_SUBMITTED:
      return { ...state, newComment: action.payload };
    default:
      throw new Error();
  }
}

export default { init, reducer };
